import { useEventListener } from "@react-hookz/web";
import { useState } from "react";
import { getWindow } from "~/lib/utils";
export function useActiveElementForNewWindow() {
  const [activeElement, setActiveElement] = useState();
  useEventListener(getWindow(), "blur", () => {
    var _document;
    if (typeof window === "undefined") return;
    setActiveElement((_document = document) === null || _document === void 0 ? void 0 : _document.activeElement);
  });
  return {
    activeElement
  };
}